import { PortfolioType } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuitePlacards.Common.PortfolioType */
export { PortfolioType };
